import { Grid, GridSize } from "@mui/material";
import React, { PropsWithChildren } from "react";


export const Column: React.FC<PropsWithChildren<{
  width: GridSize,
  className?: string,
  style?: React.CSSProperties
  sm?: GridSize
}>> = ({ width, sm, ...props }) => {
  type ResponsiveSize = Partial<Record<"xs" | "sm" | "md" | "lg" | "xl", GridSize | null>>;
  const hasSm = typeof sm !== "undefined";
  const size: ResponsiveSize = { xs: 12, md: width, ...(hasSm ? { sm } : {}) };
  return (
    <Grid size={size} {...props}>
      {props.children}
    </Grid>
  );
};
